import React from "react"
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share"
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share"

const SocialShare = ({ openShareicons, className, openBookViewformModal, role }) => {
  const shareurl = typeof window !== "undefined" ? window.location.href : ""

  const trackerShare = event => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Share - social icons",
      formType: event + " - " + shareurl,
      formId: "Share",
      formName: "Share",
      formLabel: "Share",
    })
  }

  const handleClick = () => {
    openBookViewformModal()
    trackerShare("SendToFriend")
  }

  return (
    <>
      <div
        onClick={openShareicons}
        className={`d-flex property-share-social-icons ${className ? className : ""}`}
        role={role ? role : null}
      >
        <FacebookShareButton
          onClick={() => trackerShare("FacebookShareButton")}
          url={shareurl}
          className="my-share-button facebook-share"
        >
          <FacebookIcon size={32} round={false} borderRadius={`10`} />
        </FacebookShareButton>
        <TwitterShareButton
          onClick={() => trackerShare("TwitterShareButton")}
          url={shareurl}
          className="my-share-button twitter-share"
        >
          <i className="icon-twitter-black"></i>
        </TwitterShareButton>
        <LinkedinShareButton
          onClick={() => trackerShare("LinkedinShareButton")}
          url={shareurl}
          className="my-share-button linkedin-share"
        >
          <LinkedinIcon size={32} round={false} borderRadius={`10`} />
        </LinkedinShareButton>
        <WhatsappShareButton
          onClick={() => trackerShare("WhatsappShareButton")}
          url={shareurl}
          className="my-share-button whatsapp-share"
        >
          <WhatsappIcon size={32} round={false} borderRadius={`10`} />
        </WhatsappShareButton>
        {openBookViewformModal && (
          <EmailShareButton
            url={"#"}
            onClick={handleClick}
            className="my-share-button email-share"
          >
            <EmailIcon size={32} round={false} borderRadius={`10`} />
          </EmailShareButton>
        )}
      </div>
    </>
  )
}

export default SocialShare
